import { createStyles, Theme } from "@material-ui/core";
export const OrderNotestStyle = (theme: Theme) =>
  createStyles({
    inputFile: {
      display: "none",
    },
    attachFileContainer: {
      background: "#FFFFFF",
      border: "1px solid #DFDFDF",
      boxSizing: "border-box",
      borderRadius: 4,
      width: '100%',
      '& .paddingMD': {
        padding: "6px 20px 4px",
      },
      '& .buttonSubLabel': {
        padding: "13px 0",
        '& p': {
          color: '#666'
        }
      },
      '& .attachmentIcon': {
        display: "inline-block",
        verticalAlign: "middle",
        paddingTop:8,
      },
      '& .padding30': {
          padding: '12px 0px 30px'
      },
      '& .uploadPreviewBox': {
        minHeight: 16,
        padding: "16px 0px 0px",
      },
      '& .heading': {
        padding: '16px 20px',
        borderBottom: "solid 1px rgb(223 223 223)",
        '& p': {
          fontSize: 18,
          fontWeight: 400
        }
      }
    },
    customPanle: {
      "&>:first-child": {
        marginBottom: 24,
        "&>:first-child": {
          "&>:first-child": {
            "& h6": {
              fontSize: 20,
            },
          },
          "&>:nth-child(2)": {
            backgroundColor: "transparent",
          },
        },
      },
    },
    disabledSection: {
      opacity: 0.5,
      pointerEvents: "none",
    },
    errorBorder: {
      border: "1px solid #F21D1D",
    },
    errorText: {
      color: theme.palette.error.light,
      verticalAlign: "middle",
      marginTop: "3px",
      padding: '4px 20px',
      "& svg": {
        verticalAlign: "bottom",
        marginRight: '5px',
      },
    },
    verticalSpace: {
      marginTop: "24px",
    },
    fileLabel: {
      cursor: "pointer",
      padding: '0px 6px 0px 0px'
    },
    font16:{
      fontSize: 16,
      marginBottom: 10,
    },
  });
